import React, { useEffect } from "react";
import {
  Main,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
    SeoHead,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';
import { useLanguage } from './i18n/LanguageProvider';

function App() {
    const { direction } = useLanguage();

    useEffect(() => {
        document.body.classList.remove('dark-mode', 'light-mode');
        document.body.classList.add('light-mode');
    }, []);

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
    <div className={`main-container light-mode ${direction === 'rtl' ? 'rtl' : ''}`} dir={direction}>
        <SeoHead />
        <Navigation />
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Project/>
            <Contact/>
        </FadeIn>
        <Footer />
    </div>
    );
}

export default App;